export default __webpack_public_path__ + "static/media/3600.6bc90276.png";